import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { ResponsiveBar } from '@nivo/bar'

import i18n from 'modules/core/lib/i18n'

import {
  BAR_HEIGHT,
  BAR_RADIUS,
  SMALL_BAR_HEIGHT,
  SMALL_BAR_RADIUS,
  barTheme,
} from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/lib/barsHelper'

import InfoDotMemo from './InfoDotMemo'
import { colors, generateData, keys } from './generateData'

interface Props {
  totalTransfersTimeOff: number
  totalTransfersCompensatedPayroll: number
  totalTransfersPendingToCompensatePayroll: number
  showMemo?: boolean
}

const MemoSection: React.FC<Props> = ({
  showMemo,
  totalTransfersTimeOff,
  totalTransfersCompensatedPayroll,
  totalTransfersPendingToCompensatePayroll,
}) => {
  if (!showMemo) return null

  const allZero =
    totalTransfersTimeOff === 0 &&
    totalTransfersCompensatedPayroll === 0 &&
    totalTransfersPendingToCompensatePayroll === 0

  if (allZero) return <Box padding="s8" />

  return (
    <Box flexDirection="row" gap="s8">
      {totalTransfersTimeOff !== 0 && (
        <InfoDotMemo
          color="champagne1000"
          label={i18n.t('clock_in.compensation_header.absences')}
        />
      )}
      {totalTransfersCompensatedPayroll > 0 && (
        <InfoDotMemo color="purple1000" label={i18n.t('clock_in.compensation_header.payroll')} />
      )}
      {totalTransfersPendingToCompensatePayroll > 0 && (
        <InfoDotMemo color="purple200" label={i18n.t('clock_in.compensation_header.pending')} />
      )}
    </Box>
  )
}

const Bar: React.FC<Props> = ({
  totalTransfersTimeOff,
  totalTransfersCompensatedPayroll,
  totalTransfersPendingToCompensatePayroll,
  showMemo = false,
}) => {
  const data = generateData(
    totalTransfersTimeOff,
    totalTransfersCompensatedPayroll,
    totalTransfersPendingToCompensatePayroll
  )
  const height = `${showMemo ? SMALL_BAR_HEIGHT : BAR_HEIGHT}px`
  const radius = showMemo ? SMALL_BAR_RADIUS : BAR_RADIUS

  return (
    <Box>
      <MemoSection
        showMemo={showMemo}
        totalTransfersTimeOff={totalTransfersTimeOff}
        totalTransfersCompensatedPayroll={totalTransfersCompensatedPayroll}
        totalTransfersPendingToCompensatePayroll={totalTransfersPendingToCompensatePayroll}
      />
      <Box style={{ height }}>
        <ResponsiveBar
          data={[data]}
          keys={keys}
          layout="horizontal"
          colors={colors}
          enableLabel={false}
          isInteractive={false}
          animate={false}
          borderRadius={radius}
          innerPadding={2}
          theme={barTheme}
        />
      </Box>
    </Box>
  )
}

export default Bar
